export enum AutoCapitalize {
  On = 'on',                // No autocapitalization is applied (all letters default to lowercase)
  Off = 'off',              // The first letter of each sentence defaults to a capital letter; all other letters default to lowercase
  Words = 'words',          // The first letter of each word defaults to a capital letter; all other letters default to lowercase
  Characters = 'characters' // All letters should default to uppercase
}
